import { Step, StepLabel, Stepper } from '@mui/material';
import { DEFAULT_CURRENCY, getCurrency } from '../../../../utils/currency';

/** Los pasos de la apertura/cierre de caja con varias monedas: pesos primero y después cada moneda habilitada. */
export const cashCurrencySteps = (foreignCurrencies) => [DEFAULT_CURRENCY, ...foreignCurrencies.map((currency) => currency.code)];

/** "Pesos uruguayos ($)" / "Dólares estadounidenses (US$)". */
export const currencyHeading = (code) => `${getCurrency(code).label} (${getCurrency(code).symbol})`;

/** Dónde está el cajero: una caja con varias monedas se declara una moneda por vez, y esto lo dice siempre. */
export default function CashCurrencyStepper({ foreignCurrencies, step }) {
  const steps = cashCurrencySteps(foreignCurrencies);
  if (steps.length < 2) return null;
  return (
    <Stepper activeStep={step} sx={{ mb: 3 }} data-testid="cash-currency-stepper">
      {steps.map((code) => (
        <Step key={code}>
          <StepLabel>{currencyHeading(code)}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
